import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/main.css';
import App from './App';
import './styles/dashboard.css';
import reportWebVitals from './reportWebVitals';
import 'font-awesome/css/font-awesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

// ✅ Add global error handler
const root = ReactDOM.createRoot(document.getElementById('root'));

// ✅ Add error handling for uncaught errors
window.addEventListener('error', (event) => {
  console.error('❌ Uncaught Error:', event.error);
  console.error('❌ Error Message:', event.message);
  console.error('❌ Error Stack:', event.error?.stack);
});

// ✅ Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('❌ Unhandled Promise Rejection:', event.reason);
  console.error('❌ Promise:', event.promise);
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();